import React from 'react';
import ReactDOM from 'react-dom/client';
import { initAll } from 'govuk-frontend';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'nhsuk-frontend/dist/nhsuk/nhsuk-frontend.min.css';
import './index.scss';

initAll();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
